<template>
  <div class="modal-body">
    <div><strong>1. Introduction</strong>
      <div>We respect your privacy and are committed to protecting your personal data. This Privacy Notice will inform
        you how we look after your personal data when you visit this website, register for a TG.Bet Account, or if
        you provide personal data by any other means (for example, over the phone). It also covers our collection of
        personal data from third parties and publicly available sources such as social media platforms, data
        aggregators, and credit reference agencies. It sets out your privacy rights and how the law protects them.
      </div>
      <div>We use cookies and similar technologies to collect personal data, browsing actions and patterns</div>
      <div>This Privacy Notice forms an integral part of the Player Terms and Conditions, and by accepting the Player
        Terms and Conditions, you also accept the terms of this Privacy Notice and the use of your personal data in
        accordance with this Privacy Notice. If you do not agree with the terms of this Privacy Notice, you should not
        use this website or otherwise provide us with your personal data.
      </div>
      <strong>2. Purpose of this Privacy Notice</strong>
      <div>This Privacy Notice aims to give you information on how we collect and process your personal data when you
        use this website.
      </div>
      <div>This website is not intended for children, and we do not knowingly collect personal data relating to
        children.
      </div>
      <div>It is important that you read this Privacy Notice together with any other privacy policy or fair processing
        policy that we may provide on specific occasions when we are collecting or processing personal data about you,
        so that you are fully aware of how and why we are using your data.
      </div>
      <strong>3. Who we are and how to contact us</strong>
      <div>This website and app (mutually or exclusively, as the case may be, referred to herein as the “Website”) are
        operated by MIBS B.V. , a company registered in the Commercial Register of Curaçao with number 162031 and
        address Zuikertuintjeweg Z/N (Zuikertuin Tower), Willemstad, Curacao
      </div>
      <div>MIBS B.V. (referred to as "TG.Bet", "we", "us" or "our" in this Privacy Notice) is a controller in respect
        of your personal data because we determine the purposes for which, and the way in which, your personal data is
        processed. We take our duties as data controller seriously and take full responsibility for your personal data.
      </div>
      <div>We have appointed a data privacy manager who is responsible for overseeing questions in relation to this
        Privacy Notice.
      </div>
      <div>If you have any questions about this Privacy Notice, including any requests to exercise your rights in
        relation to personal data, you should contact our data privacy manager by email: contact@TG.Bet.com.
      </div>
      <div>You have the right to make complaints at any time to the relevant data protection and privacy regulator. We
        would, however, appreciate the chance to deal with your concerns before you approach the regulator, so we kindly
        request that you contact us in the first instance.
      </div>
      <strong>4. Changes to the Privacy Notice and Players’ duty to inform us of changes</strong>
      <div>We keep this Privacy Notice under regular review. This version was last updated on the date at the bottom of
        this page.
      </div>
      <div>It is important that the personal data that we hold about Players is accurate and current. We kindly request
        that you keep us informed if your personal data changes at any time whilst you have an account with us.
      </div>
      <strong>5. Third-party links</strong>
      <div>This website may include links to third-party websites, plug-ins and applications. Clicking on those links or
        enabling those connections may allow third parties to collect or share personal data about you. We do not
        control these third-party websites and are not responsible for their privacy statements. When you leave our
        website, we encourage you to read the privacy policy of every website that you visit.
      </div>
      <strong>6. The data we collect about you</strong>
      <div>Personal data, or personal information means any information about an individual from which that person can
        be identified. It does not include data where the identity has been removed (anonymous data).
      </div>
      <div>We collect personal information which you provide directly to us, such as when you register for a TG.Bet
        Account or when you contact customer services. We also collect information from publicly available sources or
        third parties such as social media platforms and data aggregators.
      </div>
      <div>We may collect, use, store and transfer different kinds of personal data about you which we have grouped
        together as follows:
      </div>
      <div><strong>Identity Data</strong> includes first name, maiden name, last name, username or similar identifier,
        marital status, title, date of birth and gender.
      </div>
      <div><strong>Photographs</strong> include passports and other photographic identification that are collected to
        verify your identity.
      </div>
      <div><strong>Contact Data</strong> includes a billing address, home address (if different to billing address),
        email address and telephone numbers.
      </div>
      <div><strong>Financial Data</strong> includes bank account and payment card details.</div>
      <div><strong>Transaction Data</strong> includes details about deposits and withdrawals from your TG.Bet Account
        and other details of services (e.g. casino games) that you have used on the Website.
      </div>
      <div><strong>Technical Data</strong> includes internet protocol (IP) address, login data, browser type and
        version, time zone setting and location, browser plug-in types and versions, operating system and platform, and
        other technology on the devices Players use to access the Website.
      </div>
      <div><strong>Profile Data</strong> includes your usernames and passwords, our services that you have used, your
        interests, preferences, feedback and survey responses.
      </div>
      <div><strong>Usage Data</strong> includes information about how you use the Website and our products and services.
      </div>
      <div><strong>Marketing and Communications Data</strong> includes your preferences in relation to receiving
        marketing from us and third parties and your communication preferences.
      </div>
      <div>We also collect, use and share Aggregated Data such as statistical or demographic data for any purpose.
        Aggregated Data could be derived from your personal data but is not considered personal data in law as this data
        will not directly or indirectly reveal your identity. For example, we may aggregate your Usage Data to calculate
        the percentage of our customers accessing a specific feature. However, if we combine or connect Aggregated Data
        with your personal data so that it can directly or indirectly identify you, we treat the combined data as
        personal data which will be used in accordance with this Privacy Notice.
      </div>
      <strong>7. If you fail to provide personal data</strong>
      <div>Where we need to collect personal data by law, or under the terms of a contract we have with you (for
        example, where it is required under our Player Terms and Conditions), and you fail to provide that data when
        requested, we may not be able to perform the contract we have or are trying to enter into with you (for example,
        to provide you with the ability to place bets or wagers). In this case, we may have to cancel a product or
        service that you may be attempting to access, but we will notify you if this is the case at the time.
      </div>
      <strong>8. How is your personal data collected</strong>
      <div>We use different methods to collect data from and about Players including through:</div>
      <div><strong>Direct interactions:</strong> you may give us your Identity, Contact and Financial Data by filling in
        forms on the Website or by corresponding with us by post, phone, email or otherwise.
      </div>
      <div><strong>Automated technologies or interactions:</strong> As you interact with our Website, we will
        automatically collect Technical Data about your equipment, browsing actions and patterns. We collect this
        personal data by using cookies and other similar technologies. Please see below in this Privacy Notice for
        further information on cookies.
      </div>
      <div><strong>Third parties or publicly available sources:</strong> We may also receive personal data about you
        from various third parties as set out below:
      </div>
      <ul>
        <li>analytics providers;</li>
        <li>advertising networks; and</li>
        <li>search information providers.</li>
        <li>providers of technical and payment services, such as payments solutions providers (PSPs) that facilitate
          deposits and withdrawals from TG.Bet Accounts.
        </li>
        <li>data brokers or aggregators.</li>
      </ul>
      <strong>9. How we use your personal data</strong>
      <div>We collect your personal information so that we can provide an excellent level of service and so that you can
        use the Website in an agile and secure way. Collecting personal data also allows us to offer you more
        customisation on the Website.
      </div>
      <div>The table below explains when we collect your personal information, what we collect it for and why we use
        it.
      </div>
      <table style="border: 1px solid rgb(0, 0, 0);">
        <thead>
        <th><strong>When information is processed</strong></th>
        <th><strong>What information we ask for</strong></th>
        <th><strong>How and why we use your information</strong></th>
        </thead>
        <tbody>
        <tr>
          <td style="border: 1px solid rgb(0, 0, 0); padding: 5px;">When you register for a TG.Bet Account</td>
          <td style="border: 1px solid rgb(0, 0, 0); padding: 5px;">
            <div>Contact Data</div>
            <div>Identity Data</div>
            <div>Financial Data</div>
            <div>Photographs</div>
          </td>
          <td style="border: 1px solid rgb(0, 0, 0); padding: 5px;">We process this:
            <ul>
              <li>to create and manage your account with us</li>
              <li>to communicate with you about your account</li>
            </ul>
            <div>We rely on performance of a contract as the lawful basis for collecting and using your personal
              information.
            </div>
          </td>
        </tr>
        <tr>
          <td style="border: 1px solid rgb(0, 0, 0); padding: 5px;"> When we communicate with you about the management
            of your TG.Bet Account
          </td>
          <td style="border: 1px solid rgb(0, 0, 0); padding: 5px;">
            <div>Contact Data</div>
            <div>Identity Data</div>
            <div>Financial Data</div>
            <div>Transaction Data</div>
            <div>Technical Data</div>
            <div>Profile Data</div>
            <div>Marketing &amp; Communications Data</div>
          </td>
          <td style="border: 1px solid rgb(0, 0, 0); padding: 5px;">We process this:
            <ul>
              <li>to provide you with the best customised service</li>
              <li>to deal with queries and complaints</li>
            </ul>
            <div>We rely on performance of a contract as the lawful basis for collecting and using your personal
              information to manage your account.
            </div>
            <div>We rely on our legitimate interest of promoting our products and services.</div>
          </td>
        </tr>
        <tr>
          <td style="border: 1px solid rgb(0, 0, 0); padding: 5px;"> When developing our understanding of our customers
            to improve our services and website.
          </td>
          <td style="border: 1px solid rgb(0, 0, 0); padding: 5px;">
            <div>Contact Data</div>
            <div>Identity Data</div>
            <div>Transaction Data</div>
            <div>Technical Data</div>
            <div>Profile Data</div>
            <div>Usage Data</div>
            <div>Marketing &amp; Communications Data</div>
          </td>
          <td style="border: 1px solid rgb(0, 0, 0); padding: 5px;">We process this:
            <ul>
              <li>to understand the behaviors and demographics of our customers</li>
              <li>to understand our customers needs and interests</li>
            </ul>
            <div>We rely on our legitimate interest of improving our business and services</div>
          </td>
        </tr>
        <tr>
          <td style="border: 1px solid rgb(0, 0, 0); padding: 5px;"> When conducting marketing activity and determining
            what products, services and offers may be relevant to you
          </td>
          <td style="border: 1px solid rgb(0, 0, 0); padding: 5px;">
            <div>Contact Data</div>
            <div>Identity Data</div>
            <div>Transaction Data</div>
            <div>Technical Data</div>
            <div>Profile Data</div>
            <div>Usage Data</div>
            <div>Marketing &amp; Communications Data</div>
          </td>
          <td style="border: 1px solid rgb(0, 0, 0); padding: 5px;">
            <div>We rely on our legitimate interests of marketing our business, services and products</div>
            <div>To the extent that we may have obtained your consent that is only consent to receive electronic
              marketing communications it does not change the legitimate interests basis we are relying on to conduct
              our marketing activity
            </div>
          </td>
        </tr>
        <tr>
          <td style="border: 1px solid rgb(0, 0, 0); padding: 5px;"> Conducting our regulatory and compliance
            obligations
          </td>
          <td style="border: 1px solid rgb(0, 0, 0); padding: 5px;">
            <div>Contact Data</div>
            <div>Identity Data</div>
            <div>Financial Data</div>
            <div>Transaction Data</div>
            <div>Technical Data</div>
            <div>Profile Data</div>
            <div>Usage Data</div>
          </td>
          <td style="border: 1px solid rgb(0, 0, 0); padding: 5px;">
            <div>We rely on our obligation to comply with a legal obligation to share information such as with
              regulators, insurers, or government agencies. This includes conducting anti-money laundering, KYC,
              anti-fraud checks we may be required to conduct under applicable laws
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <strong>10. Marketing</strong>
      <div>You will receive marketing communications from us if either:</div>
      <div><i>(i)</i> you have a TG.Bet Account and have not opted out of receiving such marketing communications at
        the time we first collected your personal data or at any time since: or
      </div>
      <div><i>(ii)</i> If you are not a TG.Bet Account holder but have requested information from us or used
        TG.Bet services through the Website and you have opted in to receiving that marketing.
      </div>
      <div>You can ask us or third parties to stop sending you marketing messages at any time by contacting us or
        adjusting the marketing settings on the Website.
      </div>
      <div>Where you opt out of receiving these marketing messages, this will not apply to personal data provided to us
        for reasons other than marketing.
      </div>
      <strong>11. Disclosures of your personal data</strong>
      <div>We may share your personal data with the parties set out below for the purposes set out above.</div>
      <div>Internal third parties</div>
      <ul>
        <li>Other of our group companies acting as joint controllers or processors who may provide services such as IT,
          HR, customer services and system administration services and who undertake leadership reporting.
        </li>
      </ul>
      <div>External third parties</div>
      <ul>
        <li>IT service and system administration providers.</li>
        <li>Third parties that license key software to TG.Bet without which TG.Bet would not be able to provide
          services to you; for example, providers of casino games.
        </li>
        <li>Payment solutions providers to facilitate deposits and withdrawals from TG.Bet Accounts.</li>
        <li>Identity verification providers to prevent fraud.</li>
        <li>Third parties that facilitate the sending of marketing communications to you on our behalf.</li>
        <li>Professional advisers including lawyers, bankers, auditors and insurers that provide consultancy, banking,
          legal, insurance and accounting services to TG.Bet.
        </li>
        <li>Tax authorities, regulators, government agencies and other authorities that require reporting of processing
          activities in certain circumstances.
        </li>
        <li>Third parties to whom we may choose to sell, transfer or merge parts of our business or our assets.
          Alternatively, we may seek to acquire other businesses or merge with them. If a change happens to our
          business, then the new owners may use your personal data in the same way as set out in this Privacy Notice.
        </li>
      </ul>
      <div>We require all third parties to respect the security of your personal data and to treat it in accordance with
        applicable law. We do not allow our third-party service providers to use your personal data for their own
        purposes and only permit them to process your personal data for specified purposes and in accordance with our
        instructions.
      </div>
      <strong><span>12. &nbsp;Data security</span></strong>
      <p><span>We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used or accessed in an unauthorized way, altered or disclosed. In addition, we limit access to your personal data to those employees, agents, contractors and other third parties who have a business need to know. They will only process your personal data on our instructions, and they are subject to a duty of confidentiality.</span>
      </p>
      <p><span>We have put in place procedures to deal with any suspected personal data breach and will notify you and any applicable regulator of a breach where we are legally required to do so.</span>
      </p><strong><span>13. &nbsp;Data retention</span></strong>
      <p><span>We will only retain your personal data for as long as reasonably necessary to fulfil the purposes we collected it for, including for the purposes of satisfying any legal, regulatory, tax, accounting or reporting requirements. We may retain your personal data for a longer period in the event of a complaint or if we reasonably believe there is a prospect of litigation in respect to our relationship with you.</span>
      </p>
      <p><span>To determine the appropriate retention period for personal data, we consider the amount, nature and sensitivity of the personal data, the potential risk of harm from unauthorised use or disclosure of your personal data, the purposes for which we process the personal data and whether we can achieve those purposes through other means, and the applicable legal, regulatory, tax, accounting or other requirements.</span>
      </p>
      <p><span>In some circumstances, you can ask us to delete your data; to do so, please see the section 14 below for further information.</span>
      </p>
      <p><span>Sometimes we will anonymise your personal data (so that it can no longer be associated with you) for research or statistical purposes, in which case we may use this information indefinitely without further notice to you.</span>
      </p><strong><span>14. &nbsp;Your rights</span></strong>
      <p><span>Under certain circumstances, you may have the following rights under data protection laws in relation to your personal data:</span>
      </p>
      <ul>
        <li><span>&nbsp; &nbsp; </span><span>Request access</span><span>&nbsp;to your personal data (commonly known as a "data subject access request"). This enables you to receive a copy of the personal data we hold about you.</span>
        </li>
        <li><span>&nbsp; &nbsp; </span><span>Request correction</span><span>&nbsp;of the personal data that we hold about you. This enables you to have any incomplete or inaccurate data we hold about you corrected, though we may need to verify the accuracy of the new data that you provide to us.</span>
        </li>
        <li><span>&nbsp; &nbsp; </span><span>Request erasure</span><span>&nbsp;of your personal data. This enables you to ask us to delete or remove personal data where there is no good reason for us continuing to process it. You also have the right to ask us to delete or remove your personal data where you have successfully exercised your right to object to processing (see below), where we may have processed your information unlawfully or where we are required to erase your personal data to comply with local law. Note, however, that we may not always be able to comply with your request of erasure for specific legal or regulatory reasons which will be notified to you.</span>
        </li>
        <li><span>&nbsp; &nbsp; </span><span>Object to processing</span><span>&nbsp;of your personal data where there is something about a your particular situation which makes you want to object to our processing as you feel it impacts on your fundamental rights and freedoms. In some cases, we may demonstrate that we have compelling legitimate grounds to process your information which override your rights and freedoms.</span>
        </li>
        <li><span>&nbsp; &nbsp; </span><span>Request restriction of processing</span><span>&nbsp;of your personal data. This enables you to ask us to suspend the processing of your personal data in the following scenarios:</span>
        </li>
      </ul>
      <p><span>○ &nbsp; &nbsp; If you want us to establish the data's accuracy.</span></p>
      <p><span>○ &nbsp; &nbsp; Where our use of the data is unlawful but you do not want us to erase it.</span></p>
      <p><span>○ &nbsp; &nbsp; Where you need us to hold the data even if we no longer require it as you need it to establish, exercise or defend legal claims.</span>
      </p>
      <p><span>○ &nbsp; &nbsp; You have objected to our use of your data, but we need to verify whether we have overriding legitimate grounds to use it.</span>
      </p>
      <ul>
        <li><span>&nbsp; &nbsp; </span><span>Request the transfer of your personal data</span><span>&nbsp;to you or to a third party. We will provide to you, or a third party they have chosen, your personal data in a structured, commonly used, machine-readable format. Note that this right only applies to automated information which you initially provided consent for us to use or where we used the information to perform a contract with you.</span>
        </li>
      </ul>
      <p><span>If you wish to exercise any of the rights set out above, you should contact us, and we will confirm whether we are able to do so. </span>
      </p>
      <p><span>You will not have to pay a fee to access your personal data (or to exercise any of the other rights). However, we may charge a reasonable fee if your request is clearly unfounded, repetitive or excessive. Alternatively, we could refuse to comply with your request in these circumstances. </span>
      </p>
      <p><span>We may need to request specific information from you to help us confirm your identity and ensure your right to access your personal data (or to exercise any of your other rights). This is a security measure to ensure that personal data is not disclosed to any person who has no right to receive it. We may also contact you to ask you for further information in relation to your request to speed up our response.</span>
      </p>
      <p><span>We try to respond to all legitimate requests within one month. Occasionally it could take us longer than one month if your request is particularly complex or you have made a number of requests. In this case, we will notify you and keep you updated.</span>
      </p>
      <p><span>This Privacy Notice was last updated on 19/09/2023.</span></p></div>
  </div>
</template>
<style scoped>
.modal-body{
  font-size: 14px;
  line-height: 1.5715;
  word-wrap: break-word;
  color: rgba(0,0,0,.85);
}
ul{
  padding-left: 40px;

}
ul li{
  list-style: disc;
}
table{
  display: block;
  width: 100%;
  overflow-x: auto;
  border-collapse: collapse;
}
</style>
